import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Icon from './Icon';
import './TermsGate.css';

// Blocking modal shown to signed-in users who haven't accepted the current
// Terms of Service — both users who predate the terms and everyone after a
// future version bump. Not dismissible: the only ways out are Agree or Sign out.
function TermsGate() {
  const { user, acceptTerms, signOut } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!user?.needs_terms_acceptance) return null;

  const handleAgree = async () => {
    setSubmitting(true);
    setError('');
    try {
      await acceptTerms();
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
      setSubmitting(false);
    }
  };

  const isUpdate = !!user.terms_version;

  return (
    <div className="modal-overlay terms-gate-overlay">
      <div className="modal-card terms-gate-card" role="dialog" aria-modal="true" aria-labelledby="terms-gate-title">
        <div className="terms-gate-icon"><Icon name="scorecard" size={24} /></div>
        <h2 id="terms-gate-title">
          {isUpdate ? 'We’ve updated our terms' : 'One quick thing'}
        </h2>
        <p>
          {isUpdate
            ? 'Please review and accept the updated Terms of Service and Privacy Policy to keep using around.'
            : 'Please review and accept our Terms of Service and Privacy Policy to keep using around.'}
        </p>
        <p className="terms-gate-links">
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          <span aria-hidden="true">·</span>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </p>

        {error && <div className="terms-gate-error">{error}</div>}

        <button
          className="btn btn-primary btn-block"
          onClick={handleAgree}
          disabled={submitting}
        >
          {submitting ? 'Saving…' : 'I agree'}
        </button>
        <button className="terms-gate-signout" onClick={signOut} disabled={submitting}>
          Sign out instead
        </button>
      </div>
    </div>
  );
}

export default TermsGate;
